import { render, staticRenderFns } from "./tagsview.vue?vue&type=template&id=5c73ce91&scoped=true"
import script from "./tagsview.vue?vue&type=script&lang=js"
export * from "./tagsview.vue?vue&type=script&lang=js"
import style0 from "./tagsview.vue?vue&type=style&index=0&id=5c73ce91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c73ce91",
  null
  
)

export default component.exports